import { useEffect, useRef } from "react";
import fallbackAudio from "../../assets/audio/monoAudio-Trimmed.mp3";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";

interface SuccessAudioProps {
  play?: boolean;
}

const SUCCESS_AUDIO_CMS_KEY = "PM28"; // ✅ fixed CMS key

const SuccessAudio = ({ play }: SuccessAudioProps) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const hasPlayedRef = useRef(false);

  const cmsData = useAppSelector((st) => st.CmsSlice.CmsPageMessagesData);

  const audioUrl =
    cmsData?.find((i) => i.attributes.key === SUCCESS_AUDIO_CMS_KEY)?.attributes
      ?.mobileImage?.data?.attributes?.url ?? fallbackAudio;

  // 🔁 Reset when popup closes
  useEffect(() => {
    if (!play) {
      hasPlayedRef.current = false;
    }
  }, [play]);

  // 🔊 Init / update audio only when URL changes
  useEffect(() => {
    if (!audioUrl) return;

    audioRef.current = new Audio(audioUrl);
    audioRef.current.volume = 0.6;
    audioRef.current.preload = "auto";

    return () => {
      audioRef.current?.pause();
      audioRef.current = null;
    };
  }, [audioUrl]);

  // ▶️ Play once per open
  useEffect(() => {
    if (!play || hasPlayedRef.current || !audioRef.current) return;

    hasPlayedRef.current = true;
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(() => {});
  }, [play]);

  return null;
};

export default SuccessAudio;
